var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":"ساخت محصول جدید"}}),_c('crud-generator',{attrs:{"fields":_vm.fields,"name":"products"},on:{"submit":_vm.submit}},[_c('specification-selector',{on:{"specificationsUpdated":_vm.specificationsUpdated}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }